<script setup lang="ts">
import EmployerAccountsDataTable from '@/features/companies/components/EmployerAccountsDataTable.vue'

definePage({
  path: '/werkgevers-accounts',
  name: 'companies.employer-accounts.overview',
  meta: {
    title: 'Werkgevers & Uitnodigingen',
    permission: {
      resource: 'Employer',
      level: 'Read',
    },
  },
})
</script>

<template>
  <div class="pb-4 space-y-4">
    <Card>
      <template #content>
        <EmployerAccountsDataTable title="Accounts &amp; Uitnodigingen" />
      </template>
    </Card>
  </div>
</template>
